/**
 * Created by cbikar
 */
define(function (require) {

    var lpUtils = require('utils/lpUtils');
    var ViewController = require('web-agent-framework/ViewController');
    var agentLEManager = require('web-agent-utils/agentLEManager');

    var CoAppInviteDropupViewController = ViewController.extend({
        ControllerName: 'CoAppInviteDropupViewController',

        LPViewMap: {
            cobrowse_viewonly_button: '.lpview_cobrowse_dropup_item_view_only',
            cobrowse_shared_button: '.lpview_cobrowse_dropup_item_shared'
        },
        initialize: function (constructorData) {
            this.inviteOptions = constructorData.inviteOptions;
            this.onCoBrowseShared = constructorData.onCoBrowseShared;
            this.onCoBrowseView = constructorData.onCoBrowseView;

            var template = require('web-agent-templates/LP_coapp_invite_dropup.html');
            // var template = lpUtils.loadResource('web-agent-templates/LP_coapp_invite_dropup.html')
            template = this.injectTextDefaults(template, {
                cobrowseShared: agentLEManager.translateLE('LEWebAgent.COBROWSE_MENU_ITEM_TITLE_SHARED'),
                cobrowseView: agentLEManager.translateLE('LEWebAgent.COBROWSE_MENU_ITEM_TITLE_VIEW_ONLY')
            });
            this.createView({template: template});
        },

        events: function () {
            this.bindViewEvent({
                selector: this.LPViewMap.cobrowse_shared_button,
                DOMEvent: "click",
                callback: this.onCoBrowseShared
            });
            this.bindViewEvent({
                selector: this.LPViewMap.cobrowse_viewonly_button,
                DOMEvent: 'click',
                callback: this.onCoBrowseView
            });
        },

        render: function () {
            if (!this.inviteOptions.shared) {
                this.lpHide(this.LPViewMap.cobrowse_shared_button);
            }

            if (!this.inviteOptions.view) {
                this.lpHide(this.LPViewMap.cobrowse_viewonly_button);
            }
        }
    });

    return CoAppInviteDropupViewController;

});
